import { render } from "./CustomerInfo.vue?vue&type=template&id=e7cc36e6&scoped=true&lang=pug"
import script from "./CustomerInfo.vue?vue&type=script&lang=js"
export * from "./CustomerInfo.vue?vue&type=script&lang=js"

import "./CustomerInfo.vue?vue&type=style&index=0&id=e7cc36e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7cc36e6"]])

export default __exports__